<template>
  <v-container fluid class="pa-6 grey lighten-4">
    <!-- Bandeau -->

    <div
      v-if="
        this.$store.getters.currentUser.infosClientJDE.codeBlocage.length != 0
      "
      pb-12
    >
      <div style="font-weight: bold;font-size: 16px; ">
        Veuillez noter que votre compte est temporairement bloqué puisqu’une ou
        plusieurs factures inscrite(s) à votre compte client SAQ sont en retard.
        Une fois que le règlement complet de l’arriérage sera effectué, vous
        pourrez saisir de nouvelles commandes. Pour toutes questions, merci de
        communiquer avec notre Service de crédit et recouvrement au 514
        254-8686, option 2.
      </div>
    </div>

    <div v-else>
      <v-card class="pa-4 mb-6 banner-card" color="#eef6ff" flat tile>
        <v-row align="center">
          <v-col cols="auto">
            <v-icon large color="blue darken-2">mdi-clock-outline</v-icon>
          </v-col>
          <v-col>
            <span class="banner-text">
              <div
                v-if="
              dateEstimeeLivraisonTP &&
                this.$store.getters.currentUser.clientData
                  .indCommandeTPAutorise == true
            "
                class
              >
                Il vous reste
                <span
                  v-if="dateEstimeeCutOffDuration.days() > 0"
                >{{ dateEstimeeCutOffDuration.days() + ' jours ' }}</span>

                <span
                  v-if="
                dateEstimeeCutOffDuration.days() > 0 ||
                  dateEstimeeCutOffDuration.hours() > 0
              "
                >{{ dateEstimeeCutOffDuration.hours() + ' heures ' }}</span>
                {{ dateEstimeeCutOffDuration.minutes() + ' minutes ' }}
                pour transmettre votre commande pour une livraison
                {{ moment(dateEstimeeLivraisonTP).format('dddd D MMMM YYYY') }}
              </div>
            </span>
          </v-col>
        </v-row>
      </v-card>

      <v-row dense>
        <!-- COLONNE GAUCHE -->
        <v-col cols="12" md="8">
          <!-- Nouveauté -->
          <v-card class="mb-6 card">
            <v-card-title class="d-flex align-center">
              <v-icon left color="amber">mdi-star</v-icon>Nouveauté
            </v-card-title>

            <v-card-text>
              <ul
                style=" font-weight: bold; color: black"
              >Rapport d’inventaire maintenant disponible pour la restauration sur la plate-forme en ligne!</ul>
              <ul class="pt-2">
                Vous pouvez dès maintenant consulter le
                <a
                  style=" color: #474752;text-decoration: underline;padding:0.5px;font-weight: bold;"
                  @click="exportRapportinventaireB2()"
                >
                  <v-icon
                    dense
                    color="accent"
                    @click="exportRapportinventaireB2()"
                  >mdi-file-document</v-icon>Rapport des produits en inventaire
                </a>
                &nbsp;disponible à commander sur la plate-forme de commande en ligne!
              </ul>
              <ul
                class="pt-2"
              >Mis à jour quotidiennement, il vous permet d'identifier rapidement les produits disponibles et de planifier vos commandes en toute simplicité!</ul>

              <v-data-iterator
                :items="fichiers"
                hide-default-footer
                dense
                no-data-text
                class="pb-3"
              >
                <template v-if="fichiers != null" v-slot:default="props">
                  <v-col v-for="item in props.items" :key="item.name" style="padding:0.5px">
                    <ul>
                      <a
                        v-if="item.id == 1 || item.id == 2"
                        style="color: #00000099"
                        @click="exportFichier(item)"
                      >
                        Vous pouvez également consulter la
                        <span
                          style="color: #474752;text-decoration: underline;font-weight: bold;"
                        >{{ item.nomFichier }}</span>
                      </a>
                    </ul>
                  </v-col>
                </template>
              </v-data-iterator>
              <ul
                style="font-style: italic;"
              >Dernière mise à jour du rapport:&nbsp;{{ dateExecutionInventaireB2 }}</ul>
            </v-card-text>
          </v-card>

          <!-- Informations -->
          <v-card class="card">
            <v-card-title class="d-flex align-center">
              <v-icon left color="blue">mdi-information-outline</v-icon>Informations
            </v-card-title>
            <v-card-text>
              <span v-html="communication.communication"></span>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- COLONNE DROITE -->
        <v-col cols="12" md="4">
          <!-- Mes commandes -->

          <v-flex>
            <v-flex
              v-if="
            this.$store.getters.currentUser.clientData.indCommandeTPAutorise
          "
            >
              <v-card class="pl-5">
                <v-icon class="pb-6 pt-4" style="color: black">shopping_cart</v-icon>
                <span class="pl-3 pb-8" style="font-size: 12px; font-weight: bold;">MES COMMANDES</span>
              </v-card>

              <v-card class="pt-2 pb-2 pl-5">
                <router-link
                  :to="{
                name: 'historique',
                params: {
                  statutCommandeTP: 'EN_ATTENTE_RETOUR_CLIENT'
                }
              }"
                >
                  <v-avatar
                    class="accent oval"
                    size="50"
                    style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
                  >
                    <span>{{ nombreCommandeEnAttente }}</span>
                  </v-avatar>
                  <span class="button pl-5">Veuillez contacter la SAQ pour ces commandes</span>
                </router-link>
              </v-card>

              <v-card class="pt-2 pb-2 pl-5">
                <router-link
                  :to="{
                name: 'historique',
                params: {
                  statutCommandeTP: 'CONFIRMEE'
                }
              }"
                >
                  <v-avatar
                    class="accent oval"
                    size="50"
                    style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
                  >
                    <span>{{ nombreCommandeConfirmee }}</span>
                  </v-avatar>
                  <span class="button pl-5">Commandes confirmées</span>
                </router-link>
              </v-card>
            </v-flex>
          </v-flex>

          <v-flex v-if="this.$store.getters.currentUser.clientData.indDemandeIPAutorise">
            <v-spacer class="pb-2" />
            <v-card class="pl-5">
              <v-icon class="pb-6 pt-5" style="color: black">shopping_cart</v-icon>
              <span class="pl-3 pb-8" style="font-size: 12px; font-weight: bold;">MES DEMANDES</span>
            </v-card>

            <v-card class="pt-2 pb-2 pl-5">
              <router-link :to="{
                name: 'historiqueDemande'
              }">
                <v-avatar
                  class="accent oval"
                  size="50"
                  style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
                >
                  <span>{{ nombreDemandeEnAttente }}</span>
                </v-avatar>
                <span class="button pl-5 pr-1">Demandes en attente de modifications</span>
              </router-link>
            </v-card>

            <v-card class="pt-2 pb-2 pl-5">
              <router-link :to="{
                name: 'demandeBrouillon'
              }">
                <v-avatar
                  class="accent oval"
                  size="50"
                  style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
                >
                  <span>{{ nombreDemandeBrouillon }}</span>
                </v-avatar>
                <span class="button pl-5 pr-5">Demandes brouillons</span>
              </router-link>
            </v-card>
          </v-flex>

          <!-- Documents -->
          <v-card class="mt-13 card">
            <v-card-title class="d-flex align-center">
              <v-icon left color="grey darken-3">mdi-file-document-outline</v-icon>Documents
            </v-card-title>

            <v-card-text>
              <v-data-iterator :items="fichiers" item-key="id" hide-default-footer dense>
                <template #default="props">
                  <ul class="documents">
                    <li v-for="item in props.items" :key="item.id">
                      <a
                        href="javascript:void(0)"
                        style="font-size:13px;color:#6b7280"
                        @click.prevent="exportFichier(item)"
                      >{{ item.nomFichier }}</a>
                    </li>
                  </ul>
                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'
import 'moment/locale/fr'
export default {
  name: 'Accueil',
  data() {
    return {
      fichiers: [],
      fichierOffre: [],
      fichierCirculaire: [],
      filtre: null,
      communication: { communication: null },
      listeProduitsMatrice: [],
      nombreCommandeEnAttente: null,
      nombreCommandeConfirmee: null,
      nombreDemandeEnAttente: null,
      nombreDemandeBrouillon: null,
      dateEstimeeLivraisonTP: null,
      dateEstimeeLivraisonTPValideJusqua: null,
      dateEstimeeCutOffDuration: null,
      heureTombeeLivraisonCDMTp: null,
      heureTombeeLivraisonCDQTp: null,
      dateExecutionInventaireB2: null,

      headers: [{ value: 'nomFichier', sortable: false }],
      headersMatrice: [
        { value: 'noProduit', sortable: false },
        { value: 'descriptionProduit', sortable: false },
      ],
    }
  },
  computed: {},

  beforeMount() {
    console.log(' beforeMount')

    this.obtenirCommunication()
    this.obtenirDerniereExecutionRapportInventaireB2()

    if (
      this.$store.getters.currentUser.clientData.indCommandeTPAutorise == true
    ) {
      this.obtenirNombreCommandesTPEnAttenteConfirmee()
    }

    if (
      this.$store.getters.currentUser.clientData.indDemandeIPAutorise == true
    ) {
      this.obtenirNombreDemandesEnAttenteBrouillon()
    }

    if (
      this.$store.getters.currentUser.clientData.instructionLivraisonTPData !=
      null
    ) {
      this.obtenirDateLivraisonEstimee()
    }
  },

  methods: {
    obtenirCommunication() {
      console.log(
        'obtenirCommunicationSelonType ',
        this.$store.getters.currentUser.clientData.centreTraitement
      )

      var typeCommunication
      var typeClient = this.$store.getters.currentUser.clientData.typeClient

      if (typeClient != 'TITULAIRE_POUR_REVENTE') {
        typeCommunication = 'AUTRE_DEMANDEUR'
      } else if (typeClient == 'TITULAIRE_POUR_REVENTE') {
        if (
          this.$store.getters.currentUser.clientData.centreTraitement == 'CDM'
        ) {
          typeCommunication = 'TP_COMMANDE_CDM'
        } else {
          typeCommunication = 'TP_COMMANDE_CDQ'
        }
      }

      axios
        .get(`/communication/selontype/${typeCommunication}`)
        .then((response) => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.communication = resp.resultat
              this.lireDocuments()
              break
            case 'W001':
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          //console.log('error=' + error)
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    obtenirNombreCommandesTPEnAttenteConfirmee() {
      axios
        .get(
          `/accueil/commandeTPRetourClient/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then((response) => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreCommandeEnAttente = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })

      axios
        .get(
          `/accueil/commandeTPConfirmee/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then((response) => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreCommandeConfirmee = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    obtenirNombreDemandesEnAttenteBrouillon() {
      axios
        .get(
          `/accueil/demandeEnAttenteModification/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then((response) => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreDemandeEnAttente = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })

      axios
        .get(
          `/accueil/demandeEnBrouillon/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then((response) => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreDemandeBrouillon = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    obtenirDateLivraisonEstimee() {
      console.log('obtenirDateLivraisonEstimee')

      axios
        .get(
          `/calendrier/estimer/tp/${
            this.$store.getters.currentUser.clientData.idDemandeur
          }?tsCommande=${new moment().format('YYYY-MM-DDTHH:mm:ss')}`
        )
        .then((response) => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.dateEstimeeLivraisonTP = resp.resultat.dateLivraison

              this.dateEstimeeLivraisonTPValideJusqua =
                resp.resultat.dateLivraisonValideJusqua

              this.dateEstimeeCutOffDuration = moment.duration(
                this.getCutOffEstimeeDateLivraison().diff(moment())
              )

              this.$store.getters.currentUser.clientData.dateEstimeeLivraisonTP =
                resp.resultat.dateLivraison
              break
            case 'W001':
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          //console.log('error=' + error)
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })

      // Heures de tombées
      axios
        .get(`/calendrier/heures`)
        .then((response) => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.heureTombeeLivraisonCDMTp = resp.resultat.heureTombeeCdmTP
              this.heureTombeeLivraisonCDQTp = resp.resultat.heureTombeeCdqTP
              break
            case 'W001':
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          //console.log('error=' + error)
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    getCutOffEstimeeDateLivraison() {
      let heureTombee =
        this.$store.getters.currentUser.clientData.centreTraitement == 'CDM'
          ? this.heureTombeeLivraisonCDMTp
          : this.heureTombeeLivraisonCDQTp

      let time = moment(heureTombee, 'HH:mm')
      let date = moment(this.dateEstimeeLivraisonTPValideJusqua)

      date.set({ hour: time.get('hour'), minute: time.get('minute') })

      return date
    },

    lireDocuments() {
      axios
        .get(`/communication/obtenirfichiers/${this.communication.id}`)
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.fichiers = resp.resultat

              for (let i = 0; i < this.fichiers.length; i++) {
                //if (this.fichiers[i].nomFichier == 'offre.jpg') {
                //this.fichierOffre = this.fichiers[i]
                //} else if (this.fichiers[i].nomFichier == 'circulaire.jpg') {
                //  this.fichierCirculaire = this.fichiers[i]
                //}
              }

              break
            case 'W001':
              this.fichiers = []
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirDerniereExecutionRapportInventaireB2() {
      axios
        .get(`/rapport/obtenirDerniereExecutionInventaireB2`)
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.dateExecutionInventaireB2 = resp.resultat
              break
            case 'W001':
            case 'X001':
            case 'V016':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
    exportRapportinventaireB2() {
      var liste = []
      axios
        .post(
          `/rapport/${this.$store.getters.currentUser.clientData.noClientJDE}/obtenirrapportinventaireb2/`,
          liste,
          {
            responseType: 'arraybuffer',
            headers: {
              Accept: 'application/vnd.ms-excel',
            },
          }
        )
        .then((response) => {
          let ct = response.headers['content-type']
          if (ct == 'application/json') {
            const str = new TextDecoder().decode(response.data)
            const resp = JSON.parse(str)
            const msg = this.$fmtApiErr(resp)
            console.log(msg)
            this.$store.dispatch('afficherError', msg)
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'RapportProduitsInventaires.xlsx')
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    exportFichier(fichier) {
      console.log('exportFichier ' + fichier.id)

      var idFichier = fichier.id

      for (let i = 0; i < this.fichiers.length; i++) {
        // console.log(
        //   'fichiers : ' +
        //     this.fichiers[i].id +
        //    ' ' +
        //    this.fichiers[i].nomFichier
        // )

        if (fichier.nomFichier == 'offre.jpg') {
          idFichier = this.fichiers[i].id
        }
      }

      axios({
        url: '/communication/' + idFichier + '/fichier',
        method: 'get',
        responseType: 'arraybuffer',
        //headers: { Accept: 'application/pdf' }
      })
        .then((response) => {
          let ct = response.headers['content-type']
          //if (ct == 'application/json') {
          // const str = new TextDecoder().decode(response.data)
          //  const resp = JSON.parse(str)
          //  const msg = this.$fmtApiErr(resp)
          //  console.log(msg)
          //  this.$store.dispatch('afficherError', msg)
          //} else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fichier.nomFichier)
          document.body.appendChild(link)
          link.click()
          //}
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
  },
}
</script>

<style scoped>
.header {
  padding: 4px;
  text-align: left;
  color: white;
  font-size: 20px;
  width: 1500px;
}

.button {
  color: #343232;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.43px;
  line-height: 12px;
}

.v-application a {
  color: white;
}

.oval {
  height: 80.81px;
  width: 80.81px;
  background-color: #00838e;
}
div {
  font-size: 14px;
}

.lien {
  font-weight: bold;
  color: black;
  font-size: 15px;
  text-decoration: underline;
}

/* ---- Bandeau ---- */
.banner-card {
  border-radius: 12px;
  border: 1px solid #dbeafe;
}
.banner-text {
  font-weight: 600;
  font-size: 16px;
}

/* ---- Cartes communes ---- */
.card {
  border-radius: 12px !important;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.08) !important;
}

/* ---- KPI cards ---- */
.kpi {
  display: flex;
  align-items: center;
  border-radius: 12px !important;
  gap: 14px;
  color: #0b1621;
}
.kpi .kpi-value {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  display: grid;
  place-items: center;
  font-weight: 800;
}
.kpi.success {
  background: white;
  color: white;
}
.kpi.warning {
  background: #fde68a;
}

/* ---- Documents list ---- */
.documents {
  list-style: none;
  padding-left: 0;
}

.documents li {
  margin: 8px 0;
  display: flex;
  align-items: center;
}
.doc-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #1f2937;
  text-decoration: none;
}
.doc-link:hover {
  text-decoration: underline;
}
</style>
